export default __webpack_public_path__ + "static/media/concave.76c6ed56.svg";